import script from "./MobileHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileHeader.vue?vue&type=script&setup=true&lang=ts"

import "./MobileHeader.vue?vue&type=style&index=0&id=424b88b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-424b88b2"]])

export default __exports__